export default {"src":"/_next/static/media/icon-ps.c514c97f.svg","height":32,"width":104};